module.exports = __webpack_public_path__ + "static/img/metsasaatio.32fb2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metsasaatio.png
// module id = L7e4
// module chunks = 4